import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

interface LooksIconProps extends SvgIconProps {
  value: string // "1" or "12"
}

export default function LooksIcon({ value, ...props }: LooksIconProps) {
  if (value.length === 0 || value.length > 2) {
    console.warn('LooksIcon only supports 1 or 2 characters.')
    return null
  }

  return (
    <SvgIcon {...props} viewBox="0 0 24 24" aria-label={`Looks${value}`}>
      {/* Full 24x24 tile */}
      <rect x="0" y="0" width="24" height="24" rx="3" fill="currentColor" />

      {/* Digits */}
      <text
        x="12"
        y="12.6" // nudged for optical centering
        fill="#fff"
        fontFamily="Roboto, system-ui, -apple-system, Segoe UI, Arial, sans-serif"
        fontSize={value.length === 2 ? 11 : 13}
        fontWeight={800}
        textAnchor="middle"
        dominantBaseline="middle"
        letterSpacing="0.4"
      >
        {value}
      </text>
    </SvgIcon>
  )
}
